import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 512 512' {...props}>
      <title id='Cart'>{props.title || 'Cart'}</title>
      <g><path d='M440.2 328.3c-3.5 13.9-15.7 23.8-30.2 23.8H159.8c-14.5 0-27.3-9.9-30.2-23.8L65.7 69.9H34.4C16.9 69.9 3 55.9 3 38.5S16.9 7.2 34.4 7.2h55.7c14.5 0 27.3 9.9 30.8 23.8l17.4 70.3h355.9c2.9 0 6.4 1.7 8.1 4.1 2.3 2.3 2.9 5.8 1.8 8.7l-63.9 214.2zm-238.6 76c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3zm167.2 0c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3z' /></g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/cart.js